(function() {
    let codesData = [];

    async function loadAllCodes() {
        if (codesData.length > 0) return;
        try {
            // 1. JSON file load karein
            const res = await fetch(window.myAppConfig.productCodesUrl);
            let fileData = res.ok ? await res.json() : [];

            // 2. Page Metafield (code-result page) se codes uthayein
            const manualData = (window.myAppConfig.pageCodes || []).map(c => ({ "code": c.trim() }));

            // 3. Merge aur Unique banayein
            const combined = [...fileData, ...manualData];
            const uniqueMap = new Map();
            combined.forEach(item => {
                if(item.code) uniqueMap.set(item.code.toUpperCase().trim(), item);
            });

            codesData = Array.from(uniqueMap.values());
            console.log("🚀 Database Ready! Target Page: code-result. Total Codes:", codesData.length);
        } catch (e) { console.error("Load error:", e); }
    }

    function initSearch() {
        const input = document.getElementById("codeSearchInput");
        const results = document.getElementById("codeSearchResults");
        const form = input ? input.closest('form') : null;

        if (!input || !results) return;

        input.addEventListener("input", async function() {
            const value = this.value.trim().toUpperCase();
            results.innerHTML = "";
            if (value.length < 1) { results.style.display = "none"; return; }

            await loadAllCodes();

            const filtered = codesData.filter(item => item.code.toUpperCase().includes(value));

            if (filtered.length > 0) {
                filtered.slice(0, 10).forEach(item => {
                    const div = document.createElement("div");
                    div.className = "code-item";
                    div.style.cssText = "padding:10px; cursor:pointer; border-bottom:1px solid #eee; background:#fff; color:#000;";
                    div.textContent = item.code;
                    
                    div.onclick = function(e) {
                        e.preventDefault();
                        input.value = item.code;
                        results.style.display = "none";

                        // Page reload/submit logic
                        if (form) {
                            form.submit();
                        } else {
                            window.location.href = window.location.pathname + "?code=" + encodeURIComponent(item.code);
                        }
                    };
                    results.appendChild(div);
                });
                results.style.display = "block";
            } else {
                results.style.display = "none";
            }
        });

        document.addEventListener("click", function(e) {
            if (e.target !== input) results.style.display = "none";
        });
    }

    document.addEventListener("DOMContentLoaded", initSearch);
})();